import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { PageHeader, previewFile } from "common";
import getRemoteUri from "common/modules/helpers";
import { selectAccessToken } from "features/identity/identitySlice";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import moment from "moment";
import { useEffect, useState } from "react";
import { PartnerFeedItem } from "./partnerFeedApi";
import PartnerFeedViewerDialog from "./PartnerFeedViewerDialog";
import usePartnerFeedList from "./usePartnerFeedList";

export default function PartnerFeedNewsView() {
  const { hasPermissions } = useAccess();
  const token = useAppSelector(selectAccessToken);
  const { params, scope, editUrl, ...service } = usePartnerFeedList();
  const [items, setItems] = useState<PartnerFeedItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedFeed, setSelectedFeed] = useState<PartnerFeedItem | null>(
    null
  );

  useEffect(() => {
    service.loadItems("sort[]=-created_at").then((data: any) => {
      console.log({ data });
      setItems(data?.data);
      setLoading(false);
    });
  }, []);

  if (!hasPermissions("partner_feed.viewany")) {
    return null;
  }

  return (
    <>
      <PageHeader title={I18n.t("PartnerFeed.newsTitle")} />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {loading && <Typography>Betöltés...</Typography>}
        {!loading && items.length === 0 && (
          <Typography>Nincs elérhető hír.</Typography>
        )}
        {items.map((feed: PartnerFeedItem) => (
          <Card key={feed.id}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    {feed.title}
                  </Typography>
                  {feed.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1 }}
                    >
                      {feed.description}
                    </Typography>
                  )}
                  <Typography variant="caption" color="text.secondary">
                    {moment(feed.created_at).format("L LT")}
                  </Typography>
                </Box>
                {feed.file_id && (
                  <Button
                    variant="outlined"
                    startIcon={<VisibilityIcon />}
                    //onClick={() => setSelectedFeed(feed)}
                    onClick={() =>
                      previewFile({
                        url: getRemoteUri(feed.file, false) + "?token=" + token,
                        title: feed.title,
                        type: "pdf",
                      })
                    }
                  >
                    {I18n.t("PartnerFeed.viewButton")}
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
      {selectedFeed && (
        <PartnerFeedViewerDialog
          feed={selectedFeed}
          onClose={() => setSelectedFeed(null)}
        />
      )}
    </>
  );
}
